import { AttachmentService } from './../../../services/attachment.service';
import { EvaluationClientsLogsModel } from './../../../models/Common/EvaluationClientsLogsModel';
import { CommonService } from './../../../services/common.service';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../../services/home.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';


@Component({
  selector: 'testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css']
})
export class TestimonialsComponent implements OnInit {

  testimonials;
  evaluationClientsLogsModel:EvaluationClientsLogsModel[]=[];
  hideEvaluation = false;

  constructor(private attachmentService:AttachmentService,service:HomeService,private commonService:CommonService) {

   }

  ngOnInit(): void {
    this.commonService.getEvaluationClientsLogs(5,1).subscribe(res=>{

      res.forEach(item=>{
        this.evaluationClientsLogsModel.push(item);
      })

      if (this.evaluationClientsLogsModel == null) {
        this.hideEvaluation = true;
      }

    })
  }
  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayHoverPause:false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    //nav:true,
    //navText:["<h1 >Previous</h1>","<h1>Next</h1>"],
    //navText: ['Previous', 'Next'],
    responsive: {
     0: {
       items: 1
     },
      400: {
       items: 1
     },
     768: {
       items:2
     },
     940: {
       items: 3
     },
     1440:
     {
       items: 4
     },
     2560:
     {
       items: 4
     }
   },
 }
  prevBtn(){

  }
  getData(data){


  }
  dragging(data){


  }





}
